// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { LogLevel } from '../app/log-levels';

export const environment = {
  hmr: false,
  production: true,
  allowedImpersonateOrigins: ['https://admin.simplecitizen.app'],
  CLIENT_MAX_BODY_SIZE: 12,
  endpoints: {
    basePath: '/v2/api',
    apiTokenAuth: '/v2/api-token-auth/',
    meUser: '/v2/api/users/me/',
    questionnaireToken: '/v2/api/questionnaire-token/',
    resetPassword: '/v2/api/reset-password/',
    checkValidationKey: '/v2/api/check-validation/',
    setNewPassword: '/v2/api/reset/',
    dynamicConfig: '/v2/api/dynamic-config/',
    reporting: '/v2/api/reporting/',
    userApi: '/v2/api/users/',
    paymentsApi: '/v2/api/payments/',
    applicationTypeApi: '/v2/api/application-type/',
    savedReportApi: '/v2/api/saved-report/',
    reportScheduleApi: '/v2/api/report-schedule/',
    scEvent: '/v2/api/sc-event/',
    appCaseApi: '/v2/api/application-case/',
    logout: '/v2/logout/',
    impersonate: '/v2/api/users/impersonate/',
    gql: '/v2/gql',
    gqlv3: '/v3/gql',
    gqlInternal: '/v3/internal/gql',
    checkGuestToken: '/v2/api/check-guest-token/',
    checkSocial: '/auth/check-social/',
    passwordRequirement: '/v2/api/password-validation-requirements/',
    extTokens: '/api/v1/token/',
    startImpersonation: '/v3/api/start-impersonation/',
    stopImpersonation: '/v3/api/stop-impersonation/',
    sessionStatus: '/v2/api/session-status/',
    backendVersionApi: '/api/backend-version-info/',
    alloyHistoricalEmail: '/v3/api/alloy-assertion/',
    pollingTaskUrl: 'v2/api/reporting/poll-task/',
    qctXml: 'v2/api/preview-questionnaire',
    s3InitiateUpload: '/v3/s3/initiate_upload',
    s3UploadChunk: '/v3/s3/upload_chunk',
    s3CompleteUpload: '/v3/s3/complete_upload',
    fnStartApp: '/v2/api/application-case/start_app/'
  },
  keys: {
    stripePublicKey: 'pk_live_C4zRHX6z6qzeKvMsOwswM19G',
    googleMaps: 'AIzaSyCiaTLH1JkwyWnfRT3Hci13Fdwp1Ih_C1Q',
    gtm: 'GTM-PDFK9H',
    mixPanel: '80645c1e92a35a81d21f4fc423b46835',
    weglot: 'wg_6d8359c91702444a077fb05436ab64522'
  },
  sentryOpts: {
    dsn: 'https://0803990560a940159c5fd53a7e6abc76@errors.simplecitizen.net/9',
    release: 'abc2cb4a8510e9435bed7b001c3776d0766168fb',
    environment: 'consumer-prod'
  },
  review: false,
  secureCookie: true,
  cookieDomain: '.simplecitizen.com',
  csrfCookieName: 'prod_csrftoken',
  logLevel: LogLevel.ERROR,
  version: 'v6.51.0'
};
